import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';

export default function setBrandsCarousel() {
  const brandsContainer = document.querySelector('[data-swiper-brands]');

  if (brandsContainer) {
    const brandsSwiper = new Swiper(brandsContainer.querySelector('.swiper'), {
      modules: [Autoplay, Navigation, Pagination],
      slidesPerView: 1.5,
      spaceBetween: 16,
      watchOverflow: true,
      preloadImages: false,
      speed: 1000,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },
      navigation: {
        nextEl: brandsContainer.querySelector('.swiper-button-next'),
        prevEl: brandsContainer.querySelector('.swiper-button-prev'),
      },
      pagination: {
        el: brandsContainer.querySelector('.swiper-pagination'),
        type: 'bullets',
        clickable: true,
      },
      breakpoints: {
        992: {
          slidesPerView: 3,
        },
        1368: {
          slidesPerView: 5,
        },
      },
    });

    brandsSwiper.autoplay.stop();

    const initAutoplay = () => {
      brandsSwiper.autoplay.start();
    };

    const eventType = window.innerWidth <= 1024 ? 'scroll' : 'mousemove';
    window.addEventListener(eventType, initAutoplay, { once: true });
  }
}
